module.exports = __webpack_public_path__ + "img/illustrations-discount.a02ebfce.svg";